import {TableColumn} from '@fl/cmsch-fe-library';

import {MemberOfSubjectsTableType} from '../../types/member-of-subjects-table-type';

/** Table columns for the member-of-subjects tab. */
export const memberOfSubjectColumns: Array<TableColumn<MemberOfSubjectsTableType>> = [
    {
        field: 'code',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'businessName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'approvedFrom',
        type: 'date',
        dateFormat: 'date',
    },
    {
        field: 'approvedTo',
        type: 'date',
        dateFormat: 'date',
        filterTypes: ['null'],
    },
];
